import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.css';
import Home from './components/pages/Home';
import Modalpopup from './components/ModalPopup';
import Gal from './components/pages/Gallerys/Gal';
import Galc3 from './components/pages/Gallerys/Galc3';
import Galc7 from './components/pages/Gallerys/Galc7';
import Galc17 from './components/pages/Gallerys/Galc17';
import Galc19 from './components/pages/Gallerys/Galc19';
import Galc21 from './components/pages/Gallerys/Galc21';
import Galc27 from './components/pages/Gallerys/Galc27';
import Galc29 from './components/pages/Gallerys/Galc29';
import Galc25 from './components/pages/Gallerys/Galc25';
import Galc20 from './components/pages/Gallerys/Galc20';
import Slab from './components/pages/Gallerys/Slab';
import Galc15 from './components/pages/Gallerys/Galc15';
import Construction from './components/pages/Gallerys/Construction';
import Galc13 from './components/pages/Gallerys/Galc13';
import Galc5 from './components/pages/Gallerys/Galc5';
import Galm26 from './components/pages/Gallerys/Galm26';
import Galm27 from './components/pages/Gallerys/Galm27';
import Galm28 from './components/pages/Gallerys/Galm28';
import Galm29 from './components/pages/Gallerys/Galm29';
import Galm31 from './components/pages/Gallerys/Galm31';
import Galm32 from './components/pages/Gallerys/Galm32';
import Galm33 from './components/pages/Gallerys/Galm33';
import Galm34 from './components/pages/Gallerys/Galm34';
import Galm35 from './components/pages/Gallerys/Galm35';
import Galm36 from './components/pages/Gallerys/Galm36';
import Galo35 from './components/pages/Gallerys/Galo35';
import Galo36 from './components/pages/Gallerys/Galo36';
import Galo30 from './components/pages/Gallerys/Galo30';
import Galo31 from './components/pages/Gallerys/Galo31';
import Galo37 from './components/pages/Gallerys/Galo37';
import Galo39 from './components/pages/Gallerys/Galo39';
import Galo38 from './components/pages/Gallerys/Galo38';
import Galo40 from './components/pages/Gallerys/Galo40';
import Galm30 from './components/pages/Gallerys/Galm30';
import Price from './components/pages/Price';


function App() {
  return (
    
    <Router>
      
      <Routes>
        <Route path='/' element={<Home />} />
        
        <Route path='/popup' element={<Modalpopup />} />
        <Route path='/architect' element={<Gal />} />
        <Route path='/ba3' element={<Galc3 />} />
        <Route path='/ba7' element={<Galc7 />} />
        <Route path='/ba17' element={<Galc17 />} />
        <Route path='/ba19' element={<Galc19 />} />
        <Route path='/ba21' element={<Galc21 />} />
        <Route path='/ba27' element={<Galc27 />} />
        <Route path='/ba29' element={<Galc29 />} />
        <Route path='/ba25' element={<Galc25 />} />
        <Route path='/ba20' element={<Galc20 />} />
        <Route path='/slab' element={<Slab />} />
        <Route path='/ba15' element={<Galc15 />} />
        <Route path='/ba13' element={<Galc13 />} />
        <Route path='/ba5' element={<Galc5 />} />
        <Route path='/bam26' element={<Galm26 />} />
        <Route path='/bam27' element={<Galm27 />} />
        <Route path='/bam28' element={<Galm28 />} />
        <Route path='/bam29' element={<Galm29 />} />
        <Route path='/bam30' element={<Galm30 />} />
        <Route path='/bam31' element={<Galm31 />} />
        <Route path='/bam32' element={<Galm32 />} />
        <Route path='/bam33' element={<Galm33 />} />
        <Route path='/bam34' element={<Galm34 />} />
        <Route path='/bam35' element={<Galm35 />} />
        <Route path='/bam36' element={<Galm36 />} />
        <Route path='/ba35' element={<Galo35 />} />
        <Route path='/ba30' element={<Galo30 />} />
        <Route path='/ba36' element={<Galo36 />} />
        <Route path='/ba31' element={<Galo31 />} />
        <Route path='/ba37' element={<Galo37 />} />
        <Route path='/ba38' element={<Galo38 />} />
        <Route path='/ba39' element={<Galo39 />} />
        <Route path='/ba40' element={<Galo40 />} />
        <Route path='/construction' element={<Construction />} />
       
        <Route path='/price' element={<Price />} />
      </Routes>
      
    </Router>
    
  );
}


export default App;
